var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.images),function(item,i){return _c('img',{key:i,staticStyle:{"width":"100%","height":"auto !important","margin":"5px"},attrs:{"src":item,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }